// import logo from './logo.svg';
import { Button } from 'antd';
import MainView from './views/home/main';
import FAQView from './views/home/faq';
import NewsView from './views/home/news';
import ContactView from './views/home/contact';
import './App.css';
import { useState } from 'react';
import { Typography } from 'antd';

const TOOLBAR_ITEM_HOME = "Home"
const TOOLBAR_ITEM_FAQ = "FAQ"
const TOOLBAR_ITEM_NEWS = "News"
const TOOLBAR_ITEM_CONTACT = "Contact"

const TOOLBAR_ITEMS = [
  { name:  TOOLBAR_ITEM_HOME}, { name: TOOLBAR_ITEM_FAQ }, { name: TOOLBAR_ITEM_NEWS }, { name: TOOLBAR_ITEM_CONTACT },
]

function App() {
  const [current, setCurrent] = useState(TOOLBAR_ITEM_HOME)

  const onToolBarClick = name => {
    console.log("onToolBarClick", name)
    setCurrent(name)
  }

  return (
    <div className="App">
      <div className='home-top'>

        <div className='home-top-header'>
          <Typography.Title level={2}>YUUN HOME</Typography.Title>

        </div>
        <div className='home-top-toolsbar'>
          {
            TOOLBAR_ITEMS.map((value, index) => {
              // return <a className={current === value.name?'home-top-toolsbar-item-selected':'home-top-toolsbar-item'} onClick={() => onToolBarClick(value.name)}>{value.name}</a>
              return current === value.name ? <Button color="danger" size='large' variant="link" onClick={() => onToolBarClick(value.name)}>{value.name}</Button> : <Button color='primary' variant="link" onClick={() => onToolBarClick(value.name)}>{value.name}</Button>
            })
          }
        </div>
      </div>
      <div className='home-body'>
        {
          current === TOOLBAR_ITEM_HOME && <MainView onClick={ ()=> setCurrent(TOOLBAR_ITEM_FAQ)}/>
        }
        {
          current === TOOLBAR_ITEM_FAQ && <FAQView />
        }
        {
          current === TOOLBAR_ITEM_NEWS && <NewsView />
        }
        {
          current === TOOLBAR_ITEM_CONTACT && <ContactView />
        }
      </div>
      <div className='home-footer'>
        <Typography.Title level={5}>Yuun Home</Typography.Title>
        <span className='home-footer-email'>info@yuun.io</span>
        <span className='home-footer-assign'>©2023 by Yuun LLC.</span>
      </div>
    </div>
  );
}

export default App;
